// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import SiteDirectory from "./App";

import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalInstance";
// (Optional for debugging) import ErrorBoundary from "./ErrorBoundary";

msalInstance.initialize().then(() => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    // You can wrap with <ErrorBoundary> while debugging if you want:
    // <ErrorBoundary>
    <MsalProvider instance={msalInstance}>
      <SiteDirectory />
    </MsalProvider>
    // </ErrorBoundary>
  );
});
